import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  listOfProviders: [],
  listOfProducts: [],
  choices: [],
  bookingSources: [],
  coverageList: []
};

const masterdata = createSlice({
  name: 'masterdata',
  initialState,
  reducers: {
    setListOfProviders: (state, action) => {
      state.listOfProviders = action.payload;
    },
    setListOfProducts: (state, action) => {
      state.listOfProducts = action.payload;
    },
    setChoices: (state, action) => {
      state.choices = action.payload.choices;
    },
    setBookingSources: (state, action) => {
      state.bookingSources = action.payload
    },
    setCoverageList: (state, action) => {
      state.coverageList = action.payload
    }
  },
});

export const masterdataActions = masterdata.actions;

export default masterdata.reducer;
